import { Modal } from "./modal";

type TResumeViewerProps = {
    onClose: () => void;
    title: string;
    viewerUrl: string;
};

export const ResumeViewer = ({ onClose, title, viewerUrl }: TResumeViewerProps) => {
    return (
        <Modal onCloseHandler={onClose} title={title} fullScreen={true}>
            <div className="modal-body p-0 bg-light">
                <iframe src={viewerUrl} title={title} className="w-100 h-100 border-0" />
            </div>
        </Modal>
    );
};
